import $ from 'jquery';
import slick from 'slick-carousel';

export function homeInit() {
	centerHome();
	setTimeout(function() {
		$('#home_content').removeClass('fade');
	}, 10);

	var carousel = $('.carousel').slick({
		dots: false,
		autoplay: true,
		autoplaySpeed: 4000,
		accessibility: false,
		arrows: false,
		infinite: true,
		fade: true,
		pauseOnHover: false,
		speed: 1000
	});
	
	$(window).resize(function() {
		centerHome();
	});
}

function centerHome() {
	var padding = -20;
	var home_height = $('#home_content').height();
	var top_height = $('nav').height() + $('nav').offset().top + padding;
	var available_height = $(window).height() - top_height;
	
	
	if ((available_height - padding) > home_height) {
		$('#home_content').css('margin-top', ((available_height - home_height) / 2) + top_height) ;	
	} else {
		$('#home_content').css('margin-top', top_height);	
	}
}